import * as cnt from './constants';

const initialState = {
  activities: [],
  activitiesLoading: false,
  activitiesLoaded: false,
  contacts: [],
  contactsLoading: false,
  contactsLoaded: false,
  files: [],
  filesLoading: false,
  filesLoaded: false,
  partnerInfo: {},
  partnerInfoLoading: false,
  partnerInfoLoaded: false,
  newActivitySending: false,
  newActivitySendingError: false,
  resourceType: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case `${cnt.SEND_RATES}_STARTED`:
    case `${cnt.SEND_RATE_REQUESTS}_STARTED`:
    case `${cnt.SEND_MESSAGE}_STARTED`:
      return { ...state, newActivitySending: true };
    case `${cnt.SEND_RATES}_ERROR`:
    case `${cnt.SEND_RATE_REQUESTS}_ERROR`:
    case `${cnt.SEND_MESSAGE}_ERROR`:
      return { ...state, newActivitySendingError: true, newActivitySending: false };
    case `${cnt.SEND_RATES}_SUCCESS`:
    case `${cnt.SEND_RATE_REQUESTS}_SUCCESS`:
    case `${cnt.SEND_MESSAGE}_SUCCESS`:
      return { ...state, newActivitySendingError: false, newActivitySending: false };
    case `${cnt.GET_PARTNER_INFO}_STARTED`:
      return { ...state, partnerInfoLoading: true, contactsLoading: true };
    case `${cnt.GET_PARTNER_INFO}_ERROR`:
      return { ...state, partnerInfoLoading: false, contactsLoading: false, error: payload };
    case `${cnt.GET_PARTNER_INFO}_SUCCESS`:
      const {
        companyName,
        companyId,
        profileImageUrl,
        contacts,
      } = payload;
      return {
        ...state,
        contactsLoading: false,
        contactsLoaded: true,
        partnerInfoLoading: false,
        partnerInfoLoaded: true,
        partnerInfo: {
          companyName,
          companyId,
          profileImageUrl,
        },
        contacts,
        error: '',
      };
    case `${cnt.GET_FILES}_STARTED`:
      return { ...state, filesLoading: true };
    case `${cnt.GET_FILES}_SUCCESS`:
      return {
        ...state,
        files: payload.contracts,
        filesLoaded: true,
        filesLoading: false,
        resourceType: payload.resourceType,
      };
    case `${cnt.GET_FILES}_ERROR`:
      return { ...state, filesLoaded: false, filesLoading: false };
    case `${cnt.GET_ACTIVITY}_STARTED`:
      return { ...state, activitiesLoading: true };
    case `${cnt.GET_ACTIVITY}_SUCCESS`:
      return { ...state, activitiesLoaded: true, activitiesLoading: false, activities: payload };
    case `${cnt.GET_ACTIVITY}_ERROR`:
      return { ...state, activitiesLoaded: false, activitiesLoading: false };
    case cnt.CLEAR_STORE:
      return initialState;
    default:
      return state;
  }
};

export { initialState };



// WEBPACK FOOTER //
// ./src/app/components/partner-details/__store__/reducer.js